












































import { defineComponent, ref, computed, PropType } from "@vue/composition-api";
import ListFilter from "@/components/Molecules/ListFilter/index.vue";
import FilterSection from "@/components/Molecules/FilterSection/index.vue";
import SearchTextField from "@/components/Atoms/Forms/SearchTextField/index.vue";
import OccSearchMultiSelectbox from "@/components/Atoms/OccSearchMultiSelectbox/index.vue";
import DateRangeSelector from "@/components/Molecules/DateRangeSelector/index.vue";
import { useRequest } from "@/helpers/hooks/useRequest";
import { getVideoBundleUnlockingLogSearchOptions } from "@/api";
import { selectListGenerator } from "@/helpers/videoBundleUnlockingLogs";
import {
  FilterState,
  FilterType
} from "@/components/Pages/VideoBundleUnlockingLogs/Organisms/types";

export default defineComponent({
  name: "VideoBundleUnlockingLogsSearchForm",
  components: {
    ListFilter,
    FilterSection,
    OccSearchMultiSelectbox,
    SearchTextField,
    DateRangeSelector
  },
  props: {
    resetSearchForm: { type: Function as PropType<() => void>, required: true },
    filterList: {
      type: Array as PropType<
        {
          label: string;
          name:
            | "universities"
            | "graduateYears"
            | "grades"
            | "videoBundleTitles"
            | "videoChapterTitles"
            | "entryDate";
          type: FilterType;
        }[]
      >,
      required: true
    },
    filterState: {
      type: Object as PropType<FilterState>,
      required: true
    }
  },
  emits: [
    "formValueChange",
    "searchTextResetButtonClick",
    "searchFormSubmit",
    "searchFormReset"
  ],
  setup(props, { emit }) {
    const [{ data: searchOptions }] = useRequest(
      () => getVideoBundleUnlockingLogSearchOptions(),
      { immediate: true }
    );

    const selectItemList = computed(() => {
      return {
        universities: selectListGenerator(
          searchOptions.value?.universities || []
        ),
        graduateYears: selectListGenerator(
          searchOptions.value?.graduate_years || []
        ),
        grades: selectListGenerator(searchOptions.value?.grades || []),
        videoBundleTitles: selectListGenerator(
          searchOptions.value?.video_bundle_titles || []
        ),
        videoChapterTitles: selectListGenerator(
          searchOptions.value?.video_chapter_titles || []
        )
      };
    });

    const filterCount = ref(0);

    const updateFilterCountBasedOnFilterState = () => {
      const currentFilterCount = props.filterList.reduce(
        (preFilterCount: number, filter) => {
          const key: keyof typeof props.filterState = filter.name;

          if (key === "entryDate") {
            if (props.filterState[key].from || props.filterState[key].to) {
              return preFilterCount + 1;
            } else {
              return preFilterCount;
            }
          } else {
            if (props.filterState[key].length) {
              return preFilterCount + 1;
            } else {
              return preFilterCount;
            }
          }
        },
        0
      );

      filterCount.value = currentFilterCount;
    };

    const onChangeMultiSelect = (
      key: Exclude<keyof typeof props.filterState, "searchText">,
      newValue: string[]
    ) => {
      emit("formValueChange", key, newValue);
    };

    const onSearchFormSubmit = () => {
      emit("searchFormSubmit");
      updateFilterCountBasedOnFilterState();
    };

    const onSearchTextResetButtonClick = () => {
      emit("searchTextResetButtonClick");
    };

    const onSearchFormReset = () => {
      props.resetSearchForm();
      emit("searchFormReset");
      updateFilterCountBasedOnFilterState();
    };

    const currentDateStr = computed<string>(() => {
      return new Date().toISOString().slice(0, 10);
    });

    const handleChangedEntryDateFrom = (value: string) => {
      emit("changedEntryDate", { ...props.filterState.entryDate, from: value });
    };
    const handleChangedEntryDateTo = (value: string) => {
      emit("changedEntryDate", { ...props.filterState.entryDate, to: value });
    };

    return {
      filterCount,
      selectItemList,
      onChangeMultiSelect,
      onSearchFormSubmit,
      onSearchTextResetButtonClick,
      onSearchFormReset,
      currentDateStr,
      handleChangedEntryDateFrom,
      handleChangedEntryDateTo
    };
  }
});
